"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.searchResultHitService = void 0;
const app_1 = require("app");
const constants_1 = require("../constants");
class SearchResultHitService {
    constructor() {
        this.convertToProductExtraDataMap = (data) => {
            if (!data || data.length === 0)
                return {};
            const productsWithAttributes = data.filter(product => { var _a; return product !== null && ((_a = product === null || product === void 0 ? void 0 : product.attributes) === null || _a === void 0 ? void 0 : _a.length) > 0; });
            return productsWithAttributes.reduce((productExtraDataMap, product) => {
                productExtraDataMap[product.id] = {
                    id: product.id,
                    description: product.description || '',
                    images: product.images || [],
                    attributes: this.getGeneralAttributesMap(product.attributes),
                };
                return productExtraDataMap;
            }, {});
        };
        this.getGeneralAttributesMap = (attributes) => {
            const generalAttributes = attributes
                .filter(attribute => attribute.type === 'general')
                .sort((a, b) => a.name.localeCompare(b.name));
            return generalAttributes.reduce((attributesMap, attribute) => {
                var _a;
                if (attribute.name && ((_a = attribute.values) === null || _a === void 0 ? void 0 : _a.length) > 0) {
                    attributesMap[attribute.name] = attribute.values[0].description;
                }
                return attributesMap;
            }, {});
        };
        this.convertHitToTile = (hit, source, dictionary, contentDictionary = {}, productExtraData) => {
            let tile = {};
            tile.hasCardHoverEffect = true;
            switch (source) {
                case 'pages':
                    return this.getTilePagesData(hit, tile, dictionary);
                case 'products':
                    return this.getTileProductsData(hit, tile, dictionary, productExtraData);
                case 'assets':
                    return this.getTileAssetsData(hit, tile, dictionary, contentDictionary);
                default:
                    return tile;
            }
        };
        this.getTilePagesData = (hit, tile, dictionary) => {
            var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r;
            tile.id = `${hit.id}` || hit.url;
            const title = ((_b = (_a = hit.data) === null || _a === void 0 ? void 0 : _a.title) === null || _b === void 0 ? void 0 : _b[0]) || ((_d = (_c = hit.data) === null || _c === void 0 ? void 0 : _c.tileHeadline) === null || _d === void 0 ? void 0 : _d[0]) || hit.name;
            const description = ((_f = (_e = hit.data) === null || _e === void 0 ? void 0 : _e.tileDescription) === null || _f === void 0 ? void 0 : _f[0]) || '';
            tile.title = (0, app_1.textFromHTMLString)(title);
            tile.description = (0, app_1.textFromHTMLString)(description);
            tile.link = { url: hit.url };
            const tagsArray = [];
            !!hit.contentTypeAlias &&
                tagsArray.push(dictionary[hit.contentTypeAlias] || hit.contentTypeAlias);
            !!((_h = (_g = hit.data) === null || _g === void 0 ? void 0 : _g.segmentsTaxonomy) === null || _h === void 0 ? void 0 : _h[0]) &&
                tagsArray.push(dictionary[(_k = (_j = hit.data) === null || _j === void 0 ? void 0 : _j.segmentsTaxonomy) === null || _k === void 0 ? void 0 : _k[0]] || ((_m = (_l = hit.data) === null || _l === void 0 ? void 0 : _l.segmentsTaxonomy) === null || _m === void 0 ? void 0 : _m[0]));
            tile.tag = tagsArray.join(' | ');
            if ((_p = (_o = hit.data) === null || _o === void 0 ? void 0 : _o.tileImage) === null || _p === void 0 ? void 0 : _p[0]) {
                tile.image = (_r = (_q = hit.data) === null || _q === void 0 ? void 0 : _q.tileImage) === null || _r === void 0 ? void 0 : _r[0];
                tile.imageAltText = title;
            }
            return tile;
        };
        this.getTileProductsData = (hit, tile, dictionary, productExtraData) => {
            var _a, _b, _c, _d, _e, _f;
            tile.title = (hit === null || hit === void 0 ? void 0 : hit.slug) || hit.id;
            const segmentTag = this.getTags(hit, ['segmentsTaxonomy']);
            tile.tag = dictionary[segmentTag] || segmentTag;
            tile.id = hit.id;
            tile.link = {
                url: `https://store.danfoss.com/p/${hit.id}/`,
                newWindow: true,
            };
            tile.isExternalLink = true;
            if (productExtraData && !(0, app_1.isObjectEmpty)(productExtraData === null || productExtraData === void 0 ? void 0 : productExtraData.attributes)) {
                tile.attributes = productExtraData.attributes;
            }
            if ((_b = (_a = productExtraData === null || productExtraData === void 0 ? void 0 : productExtraData.images) === null || _a === void 0 ? void 0 : _a[0]) === null || _b === void 0 ? void 0 : _b.url) {
                tile.image = (_d = (_c = productExtraData.images) === null || _c === void 0 ? void 0 : _c[0]) === null || _d === void 0 ? void 0 : _d.url;
                tile.imageAltText = (_f = (_e = productExtraData.images) === null || _e === void 0 ? void 0 : _e[0]) === null || _f === void 0 ? void 0 : _f.title;
            }
            if (productExtraData === null || productExtraData === void 0 ? void 0 : productExtraData.description) {
                tile.description = (0, app_1.textFromHTMLString)(productExtraData.description);
            }
            return tile;
        };
        this.getTileAssetsData = (hit, tile, dictionary, contentDictionary = {}) => {
            var _a, _b, _c;
            tile.id = (hit === null || hit === void 0 ? void 0 : hit.id) || (hit === null || hit === void 0 ? void 0 : hit.url);
            const translatedHeading = (_a = contentDictionary[hit === null || hit === void 0 ? void 0 : hit.id]) === null || _a === void 0 ? void 0 : _a.title;
            tile.isDocument = true;
            tile.title = translatedHeading
                ? (0, app_1.textFromHTMLString)(translatedHeading)
                : (0, app_1.textFromHTMLString)(hit.title);
            if (!tile.title && (hit === null || hit === void 0 ? void 0 : hit.titles) && Object.values(hit === null || hit === void 0 ? void 0 : hit.titles)[0]) {
                const titleValues = Object.values(hit.titles);
                tile.title = (0, app_1.textFromHTMLString)(titleValues[0]);
            }
            if (hit.url) {
                tile.link = { url: hit.url, newWindow: true };
            }
            tile.tag = this.getAssetTags(hit, dictionary);
            const validForTags = (_b = this.getAssetValidForTags(hit, dictionary)) !== null && _b !== void 0 ? _b : {};
            const gtmFields = (_c = this.getGtmFieldsForAsset(hit)) !== null && _c !== void 0 ? _c : {};
            tile = Object.assign(Object.assign(Object.assign({}, tile), validForTags), gtmFields);
            return tile;
        };
        this.getTranslation = (array, dictionary) => array.map(item => dictionary[item] || item);
        this.getLanguageTag = (hit, dictionary) => {
            if (!(!hit.languages || (hit.languages && !hit.languages.length)) && hit.languages.length > 1) {
                return dictionary.multilanguage;
            }
            else {
                return dictionary[hit.languages[0]] || hit.languages[0];
            }
        };
        this.getAssetTags = (hit, dictionary) => {
            const tagsArray = [];
            !!hit.assetSubType && tagsArray.push(dictionary[hit.assetSubType] || hit.assetSubType);
            !!hit.softwareCharacteristicDefinitionIds[0] &&
                tagsArray.push(dictionary[hit.softwareCharacteristicDefinitionIds[0]] ||
                    hit.softwareCharacteristicDefinitionIds[0]);
            const languages = this.getLanguageTag(hit, dictionary);
            !!languages && tagsArray.push(languages);
            !!hit.fileExtension && tagsArray.push(hit.fileExtension);
            !!hit.fileSize && tagsArray.push((0, app_1.formatBytes)(hit.fileSize));
            !!hit.updatedDate && tagsArray.push(this.createDateString(dictionary.updated, hit.updatedDate));
            !!hit.authority && tagsArray.push(hit.authority);
            (hit === null || hit === void 0 ? void 0 : hit.status) === 'Archived' && tagsArray.push(dictionary[hit.status] || hit.status);
            return tagsArray.join(' | ');
        };
        this.getAssetValidForTags = (hit, dictionary) => {
            var _a;
            if (((_a = hit === null || hit === void 0 ? void 0 : hit.countries) === null || _a === void 0 ? void 0 : _a.length) === 0) {
                return {};
            }
            return {
                isGlobal: (0, app_1.isGlobalCountry)(hit.countries),
                validFor: this.getTranslation(hit.countries, dictionary),
                validForLabel: dictionary.validForLabel,
                multipleLabel: dictionary.multipleLabel,
                globalTooltipMessage: dictionary.globalTooltipMessage,
                multipleTooltipMessage: dictionary.multipleTooltipMessage,
            };
        };
        this.getGtmFieldsForAsset = (hit) => {
            const gtmFields = {};
            !!(hit === null || hit === void 0 ? void 0 : hit.assetSubType) && (gtmFields.documentType = (hit === null || hit === void 0 ? void 0 : hit.assetSubType) || '');
            if ((hit === null || hit === void 0 ? void 0 : hit.segments) && hit.segments.length > 0) {
                gtmFields.segments = constants_1.GTM_SEGMENT_CODE_MAP[hit.segments[0]]
                    ? [constants_1.GTM_SEGMENT_CODE_MAP[hit.segments[0]]]
                    : [hit.segments[0]];
            }
            !!(hit === null || hit === void 0 ? void 0 : hit.fileExtension) && (gtmFields.fileType = (hit === null || hit === void 0 ? void 0 : hit.fileExtension) || '');
            return gtmFields;
        };
        this.getTags = (hit, fields = []) => fields
            .reduce((acc, field) => {
            if (!!hit[field] && hit[field].length) {
                Array.isArray(hit[field]) ? acc.push(hit[field].join(' | ')) : acc.push(hit[field]);
            }
            return acc;
        }, [])
            .join(' | ');
        this.createDateString = (dateLabel, dateValue) => {
            const formattedDate = app_1.DateService.formatDate(dateValue, constants_1.DATE_FORMAT);
            return dateLabel ? `${dateLabel}: ${formattedDate}` : formattedDate;
        };
    }
}
exports.searchResultHitService = new SearchResultHitService();
